import { useLocation, useNavigate } from "react-router-dom";
import { capitalizeFirstLetter } from "../../utils/funcs/common";
import { useState } from "react";

interface navIcons {
  id: string;
  label?: string;
  onClickFn?: () => void;
  subnavs?: string[];
}

const NavbarIcon = ({ id, label, onClickFn, subnavs }: navIcons) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isSubnavOpen, setIsSubnavOpen] = useState(false);

  return (
    <div className="nav-icon-container">
      <button
        type="button"
        className={
          location.pathname.toLowerCase() === `/${id.toLowerCase()}` ||
          location.pathname.toLowerCase().startsWith(`/${id.toLowerCase()}/`)
            ? "nav-link-button nav-link-button--active"
            : "nav-link-button" + (isSubnavOpen ? " subnav-open" : "")
        }
        id={id}
        onClick={() => {
          if (subnavs) {
            setIsSubnavOpen(!isSubnavOpen);
          } else {
            navigate(`/${id}`);
            if (onClickFn) {
              onClickFn();
            }
          }
        }}
      >
        {label || capitalizeFirstLetter(id)}{" "}
        {subnavs && (
          <i className={`bi bi-caret-${isSubnavOpen ? "up" : "down"}-fill`}></i>
        )}
      </button>
      <ul className="subnav-list">
        {subnavs?.map((subnav) => (
          <li
            key={subnav}
            onClick={() => {
              navigate(`/${id}/${subnav}`);
              setIsSubnavOpen(false);
            }}
          >
            {capitalizeFirstLetter(subnav)}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default NavbarIcon;
